import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';
import { AlmacenEquiposRoutingModule } from './almacen-equipos-routing.module';
import { AlmacenEquiposComponent } from './almacen-equipos.component';
import { AsignacionEquiposComponent } from './asignacion-equipos/asignacion-equipos.component';
import { DialogAsignarEquiposComponent } from './asignacion-equipos/dialog-asignar-equipos/dialog-asignar-equipos.component';
import { DialogVerEquiposComponent } from './asignacion-equipos/dialog-ver-equipos/dialog-ver-equipos.component';
import { AsignarEquiposFileComponent } from './asignar-equipos-file/asignar-equipos-file.component';
import { DialogAsignarEquiposFileComponent } from './asignar-equipos-file/dialog-asignar-equipos-file/dialog-asignar-equipos-file.component';
import { CategoriaAgrupadoComponent } from './categoria-agrupado/categoria-agrupado.component';
import { DialogAsignarProductoComponent } from './categoria-agrupado/dialog-asignar-producto/dialog-asignar-producto.component';
import { DialogAsignarTiposComponent } from './egreso-equipos/dialog-asignar-tipos/dialog-asignar-tipos.component';
import { DialogPaxComponent } from './egreso-equipos/dialog-pax/dialog-pax.component';
import { DialogVerDocumentoComponent } from './egreso-equipos/dialog-ver-documento/dialog-ver-documento.component';
import { EgresoEquiposComponent } from './egreso-equipos/egreso-equipos.component';
import { DialogIngresoEquipoComponent } from './ingreso-equipos/dialog-ingreso-equipo/dialog-ingreso-equipo.component';
import { IngresoEquiposComponent } from './ingreso-equipos/ingreso-equipos.component';
import { DialogIngresoAventuraComponent } from './ingreso/dialog-ingreso-aventura/dialog-ingreso-aventura.component';
import { IngresoComponent } from './ingreso/ingreso.component';
import { DialogInventarioAventuraComponent } from './inventario/dialog-inventario-aventura/dialog-inventario-aventura.component';
import { InventarioComponent } from './inventario/inventario.component';
import { DialogListaEquiposComponent } from './lista-equipos/dialog-lista-equipos/dialog-lista-equipos.component';
import { ListaEquiposComponent } from './lista-equipos/lista-equipos.component';
import { ReporteComponent } from './reporte/reporte.component';

@NgModule({
  declarations: [
    AlmacenEquiposComponent,
    InventarioComponent,
    IngresoComponent,
    DialogIngresoAventuraComponent,
    DialogInventarioAventuraComponent,

    IngresoEquiposComponent,
    DialogIngresoEquipoComponent,
    AsignacionEquiposComponent,
    DialogVerEquiposComponent,
    DialogAsignarEquiposComponent,
    ReporteComponent,
    ListaEquiposComponent,
    DialogListaEquiposComponent,
    CategoriaAgrupadoComponent,
    DialogAsignarProductoComponent,
    AsignarEquiposFileComponent,
    DialogAsignarTiposComponent,
    EgresoEquiposComponent,
    DialogAsignarEquiposFileComponent,
    DialogVerDocumentoComponent,
    DialogPaxComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AlmacenEquiposRoutingModule,
    RouterModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
  ],
})
export class AlmacenEquiposModule {}
